<div class="row container-details">
  <div class="col" *ngIf="container?.vesselName">
    <label class="label">{{'shipments.ocean_shipments.vessel_name_txt' | translate}}</label>
    <p>
      <span span class="value">
        {{getVesselNameNumber(container) || ''}}
      </span>
    </p>
  </div>

  <div class="col" *ngIf="Utility.isRoadShipment(container?.shippingMode)">
    <label class="label">{{'shipments.road_shipments.vehicle_no_txt' | translate}} </label>
    <p>
      <span span class="value">{{container?.transportJourneys?.roadTransport?.truckNumber || ''}}</span>
    </p>
  </div>

  <div class="col" *ngIf="container?.containerNumber">
    <label class="label">{{'common.container_#_txt' | translate}}</label>
    <p>
      <span span class="value">
        {{container?.containerNumber || ''}}
      </span>
    </p>
  </div>

  <div class="col" *ngIf="container?.containerSize">
    <label class="label">{{'shipments.ocean_shipments.container_type_txt' | translate}}</label>
    <p><span class="value">
        {{container?.containerSize || ''}}
      </span>
      &nbsp;
      <span span class="value">
        {{container?.containerType || ''}}
      </span>
    </p>
  </div>

  <div class="col" *ngIf="container?.status">
    <label class="label">{{'common.status_txt' | translate}}</label>
    <p class="text-bold status">
      <!-- <span class="value">{{container.status | shipmentStatus}}</span> -->
      <span [innerHTML]="container?.status | shipmentStatus"></span>
    </p>
  </div>

  <!-- Interport (100003537) as a client has requested that the MBL needs to be hidden when public link is being shared -->
  <div class="col" *ngIf="container?.blNumber && container?.organizationId != '100003537'">
    <label class="label">{{'common.mbl_#_txt' | translate}}</label>
    <p>
      <span class="value">{{container?.blNumber || '' }}</span>
    </p>
  </div>

  <div class="col" *ngIf="container?.bkNumber">
    <label class="label">{{'common.booking_#_txt' | translate}}</label>
    <p>
      <span class="value">{{container?.bkNumber || '' }}</span>
    </p>
  </div>

  <div class="col" *ngIf="container?.referenceNumber">
    <label class="label">{{'common.shipment_reference_txt' | translate}}</label>
    <p>
      <span class="value">{{container?.referenceNumber || '' }}</span>
    </p>
  </div>

  <div class="col" *ngIf="container?.transportJourneys?.portToPort; let p">
    <label class="label">{{'common.carrier_txt' | translate}}</label>
    <p>
      <span class="value">{{p?.carrier || '' }}</span>
    </p>
  </div>

  <div class="col" *ngIf="container?.emissions?.co2e?.value let v">
    <label class="label">{{'common.co2_emissions_txt' | translate}}</label>
    <p>
      <span class="value">{{ v | number : '1.0-2' }} {{container?.emissions?.co2e?.unit || '' }}</span>
      <span>
        <dp-svg [src]="udsIconMap.infoExclamation" w="16" placement="bottom"
          tooltip="Total Port to Port GHG emission basis GLEC framework Default factors"></dp-svg>
      </span>
    </p>
  </div>


</div>